import { Attribute, JsonApiModel, JsonApiModelConfig } from 'angular2-jsonapi'
import { environment } from '../../../environments/environment'

@JsonApiModelConfig({
    type: 'fotos'
})
export class Foto extends JsonApiModel {
    static SEM_FOTO_IMG_URL = 'https://cdn.alterdata.com.br/pack/packup/Content/images/no-avatar.jpg'

    @Attribute() imagem: string
    @Attribute() tamanho: number

    get imagemSrc() {
        if (!this.imagem) {
            throw new Error('Imagem vazia ou não carregada.')
        }

        return `data:image/png;base64,${this.imagem}`
    }

    getThumbnailUrl(width = 90, height: number = null, quality = 75) {
        const hParam = height ? `&h=${height}` : ''

        return `${environment.packupBaseUrl}/Foto/Visualizar/${
            this.id
        }?w=${width}${hParam}&q=${quality}`
    }
}



// WEBPACK FOOTER //
// ./src/app/pkw-data/core/foto.model.ts